import script from "./MobileLabelsSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileLabelsSheet.vue?vue&type=script&setup=true&lang=ts"

import "./MobileLabelsSheet.vue?vue&type=style&index=0&id=20510fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20510fea"]])

export default __exports__